/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manual_Qc_No_Related_EventsInputs */



/**
* | output |
* | --- |
* | "This issue is not related to any events" |
*
* @param {Manual_Qc_No_Related_EventsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const manual_qc_no_related_events = /** @type {((inputs?: Manual_Qc_No_Related_EventsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manual_Qc_No_Related_EventsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Cet incident n'est lie a aucun evenement")
	if (locale === "de") return /** @type {LocalizedString} */ ("Dieses Problem steht in keinem Zusammenhang mit irgendwelchen Ereignissen.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Questo problema non è correlato ad alcun evento")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Данная проблема не связана ни с какими событиями.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Este problema no está relacionado con ningún evento.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("这个问题与任何事件无关。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("この問題はいかなるイベントとも関係ありません")
	if (locale === "hi") return /** @type {LocalizedString} */ ("यह मुद्दा किसी घटना से संबंधित नहीं है।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Este problema não está relacionado a nenhum evento.")
	return /** @type {LocalizedString} */ ("This issue is not related to any events")
});